'use strict';

const _ = require('lodash');
const jQuery = require('jquery');

const Translator = require('./../../../core/translator');
const Container = require('./../../../core/container');
const UserPrefRepo = require('./../../content/repository/UserPreferenceRepository');

const zone = require('./../../../services/structure/zone');
const FormBuilder = require('./../../../services/form');
const Notifier = require('./../../../services/notifier');
const Help = require('./../../../services/help');
const Loader = require('./../../../services/loader');

let errors = [404, 500];

const onSubmit = function(error, data) {
    zone.hidePanels(Container.get('$smallPanel'));

    UserPrefRepo.save('error_page_' + error, data).done(function() {
        Notifier.success(Translator.translate('parameters_saved'));
    });
};

const onErrorClick = function(event) {
    let error = event.data.error;
    let $container = jQuery('<div></div>');

    let $layer = zone.addLayer(Translator.translate(`page_error_${error}_settings`), $container, {
        'extraTitle': Help.createLink(`error_management_${error}`),
    });

    Loader.start($layer);

    UserPrefRepo.find('error_page_' + error).done(function(data) {
        let form = FormBuilder.getForm({
            'elements': {
                'title': {
                    'type': 'text',
                    'label': Translator.translate('page_error_title'),
                    'value': data.title || '',
                },
                'description': {
                    'type': 'textarea',
                    'label': Translator.translate('page_error_description'),
                    'value': data.description || '',
                    'resize': false,
                    'rows': 5,
                },
                'button_title': {
                    'type': 'text',
                    'label': Translator.translate('page_error_button_title'),
                    'value': data.button_title || '',
                    'placeholder': Translator.translate('page_error_button_placeholder'),
                },
            },
            'form': {
                'submit_class': 'd-none',
            },
        });

        $container.append(form.render());

        Loader.stop($layer);

        form.on('submit', onSubmit.bind(undefined, error));

        zone.setFooter($layer, zone.createSubmitButtons({
            onSubmitClick: form.submit.bind(form),
        }));
    });
};

module.exports.onClick = function() {
    let $container = jQuery('<ul class="cloud-list list-unstyled"></ul>');

    _.forEach(errors, (error) => {
        let $item = jQuery(`<li><button class="btn btn-default btn-block">${Translator.translate('page_error')} ${error}</button></li>`);

        $item.on('click', {
            'error': error,
        }, onErrorClick);

        $container.append($item);
    });

    zone.addLayer(Translator.translate('page_errors'), $container);
};
